import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useApp } from "../context/AppContext";
import { StickerStudio } from "./StickerStudio";
import { mediaToFile, saveStaticSticker, saveAnimatedSticker, stickerErrorKey } from "./StickerTray";

/** "Make a sticker" from a photo/video already in the chat: downloads the media → Sticker Studio → saves to "Mine". */
export function MessageStickerStudio({ media, onClose }) {
  const { t } = useApp();
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (!media) return undefined;
    let alive = true;
    setFile(null);
    mediaToFile(media)
      .then((f) => { if (alive) setFile(f); })
      .catch(() => { if (alive) { toast.error(t("something_wrong")); onClose(); } });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media?.id]);

  if (!media) return null;
  const done = () => { toast.success(t("sticker_saved_hint")); onClose(); };
  return (
    <StickerStudio
      open={!!file}
      file={file}
      onClose={onClose}
      onCreateStatic={async (b64) => { try { await saveStaticSticker(b64); done(); } catch (e) { toast.error(t("something_wrong")); } }}
      onCreateAnimated={async (fd) => { try { await saveAnimatedSticker(fd); done(); } catch (e) { toast.error(t(stickerErrorKey(e))); } }}
    />
  );
}
